
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { EscrowContract } from "../../types/escrow";

const MOCK_WALLET_2 = 'SUI_Su...k9b';
const MOCK_WALLET_SOL_EXT = 'SOL_Sf...k4m';
const MOCK_WALLET_CURRENT_USER = "SOL_Ph...9x2"; 

export const MOCK_SUI_ESCROWS: EscrowContract[] = [
    {
        id: 'sui_esc_1a2b3c',
        title: 'Website Design Contract',
        chain: 'SUI',
        buyer: MOCK_WALLET_CURRENT_USER,
        seller: MOCK_WALLET_2,
        token: 'SUI',
        total: 2500,
        milestones: [
            { index: 0, title: 'Initial Deposit', amount: 500, released: true, status: 'released' },
            { index: 1, title: 'Design Mockups Approved', amount: 1000, released: false, status: 'funded' },
            { index: 2, title: 'Final Delivery', amount: 1000, released: false, status: 'pending' },
        ],
        stealth: true,
        status: 'active',
        createdAt: Date.now() - 86400000 * 5, 
        expiresAt: Date.now() + 86400000 * 25, 
        txHash: '0x...sui_tx_hash'
    }
];

export const MOCK_SOL_ESCROWS: EscrowContract[] = [
    {
        id: 'sol_esc_4d5e6f',
        title: 'Q4 Marketing Campaign',
        chain: 'SOL',
        buyer: MOCK_WALLET_SOL_EXT,
        seller: MOCK_WALLET_CURRENT_USER,
        token: 'USDC',
        total: 15000,
        milestones: [
            { index: 0, title: 'Strategy Document', amount: 3000, released: true, status: 'released' },
            { index: 1, title: 'Ad Creatives Delivered', amount: 5000, released: true, status: 'released' },
            { index: 2, title: 'Campaign Launch', amount: 7000, released: false, status: 'approved' },
        ],
        stealth: false,
        status: 'active',
        createdAt: Date.now() - 86400000 * 12,
        expiresAt: Date.now() + 86400000 * 18,
        txHash: '...sol_tx_hash'
    },
    {
        id: 'sol_esc_7g8h9i',
        title: 'Solana Devnet Audit',
        chain: 'SOL',
        buyer: 'SOL_Corp_Audit_99',
        seller: MOCK_WALLET_CURRENT_USER,
        token: 'SOL',
        total: 50,
        milestones: [
            { index: 0, title: 'Code Access Provided', amount: 10, released: true, status: 'released' },
            { index: 1, title: 'Preliminary Report', amount: 40, released: false, status: 'funded' },
        ],
        stealth: true,
        status: 'active',
        createdAt: Date.now() - 86400000 * 2,
        expiresAt: Date.now() + 86400000 * 10,
        txHash: '...sol_audit_tx'
    }
];
